import * as mutationTypes from '@/types/mutationTypes';
import * as getterTypes from '@/types/getterTypes';
import { actionTypes } from '@/types';
import { areRouteParamsEqual } from '@/tools/areRouteParamsEqual';
const navigationDirectionTypes = {
	left: 'left',
	right: 'right',
	push: 'push',
};

export default {
	state: {
		enableHistorySwipe: true,
		articleProperties: {
			left: null,
			current: null,
			right: null,
			history: null,
		},
		direction: null,
		isRouterAction: false,
		updatedBy: null,
	},
	getters: {
		[getterTypes.pageTransitionSwipe]: (state, getters, rootState) => {
			switch (rootState.pageTransitionMode) {
				case 'swipe':
					return true;
				case 'simple':
					return false;
				default:
					return rootState.isApp || rootState.isPreview;
			}
		},
	},
	mutations: {
		[mutationTypes.swipeEnableHistory](state, payload) {
			state.enableHistorySwipe = typeof payload === 'undefined' ? true : payload;
		},
		[mutationTypes.swipeSetArticleProperties](state, { articleProperties, updatedBy }) {
			state.articleProperties = articleProperties;
			state.updatedBy = updatedBy;
		},
		[mutationTypes.swipeSetDirection](state, { direction }) {
			state.direction = direction;
		},
		[mutationTypes.swipeIsRouterAction](state, isRouterAction) {
			state.isRouterAction = isRouterAction;
		},
	},
	actions: {
		[actionTypes.swipeUpdateArticlePoperties](
			{ commit, getters, state },
			{ leftArticleProperties, rightArticleProperties, updatedBy }
		) {
			// set article informations  from left to right.
			// Middle position is always current article.
			// If history swipe is enabled browsing history fills left an right by historry stack informations.
			/* eslint-disable */
			const newArticleProperties = {
				left: leftArticleProperties
					? leftArticleProperties
					: state.enableHistorySwipe
					? getters[getterTypes.historyPrev]
					: null,
				current: getters[getterTypes.historyCur],
				right: rightArticleProperties
					? rightArticleProperties
					: state.enableHistorySwipe
					? getters[getterTypes.historyNext]
					: null,
				history: getters[getterTypes.historyPrev],
			};
			/* eslint-enable */

			// Check in which direction article has moved and if it has changed use left and right ArticleProperties
			// for direction estimation, beacause history fille swipe properties can be overwritten by contentUI set left and right
			// so position of last current is not correct.
			if (
				state.articleProperties.current &&
				!areRouteParamsEqual(newArticleProperties.current, state.articleProperties.current)
			) {
				if (areRouteParamsEqual(newArticleProperties.current, state.articleProperties.left))
					commit(mutationTypes.swipeSetDirection, { direction: navigationDirectionTypes.right });
				else if (areRouteParamsEqual(newArticleProperties.current, state.articleProperties.right))
					commit(mutationTypes.swipeSetDirection, { direction: navigationDirectionTypes.left });
				else commit(mutationTypes.swipeSetDirection, { direction: navigationDirectionTypes.push });
			}
			// changes in left or wright article-wrapper is not visible by user but has to be updated
			commit(mutationTypes.swipeSetArticleProperties, {
				articleProperties: newArticleProperties,
				updatedBy,
			});
		},
	},
};
